import { ConfigManagementLogActions, ConfigManagementLogPayload, ConfigManagementLogsState, DEFAULT_LOGS_PAGE_SIZE } from "./types";

const initialState: ConfigManagementLogsState = {
  items: [],
  totalElements: 0,
  filter: {},
  page: 1,
  pageSize: DEFAULT_LOGS_PAGE_SIZE,
}

export default function (state = initialState, action: ConfigManagementLogPayload){
  switch(action.type) {
    case(ConfigManagementLogActions.setList):
      return action.payload

    case(ConfigManagementLogActions.clearList):
      return initialState
      
    default:
      return state
  }
}
